<template>
    <div class="cz2__ai-modal__selfie-get-ready">
        <div class="cz2__ai-modal__selfie-get-ready-wrapper">
            <div class="cz2__ai-modal__selfie-example" />

            <div class="cz2__modal-popup__header">
                {{ $t('AI_SELFIE_HEADING') }}
            </div>

            <p class="cz2__modal-popup__copy">
                {{ $t('AI_SELFIE_COPY') }}
            </p>

            <btn
                primary
                @click="openSayCheeseState"
            >
                {{ $t('AI_CONTINUE') }}
                <img
                    src="../../assets/icons/chevron.svg"
                    width="auto"
                    height="12"
                >
            </btn>
        </div>

        <base-disclaimer :message-copy="$t('AI_DISCLAIMER')" />
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal__selfie-get-ready {
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                background-color: #fff;

                .cz2__ai-modal__selfie-get-ready-wrapper {
                    margin-top: auto;
                    margin-bottom: auto;
                    padding-top: 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 6px;
                }

                .cz2__ai-modal__selfie-example {
                    margin-bottom: 8px;
                    background-image: url('../../assets/images/ai-selfie-frame.svg');
                    background-repeat: no-repeat;
                    background-size: contain;
                    width: 100%;
                    height: auto;
                    aspect-ratio: 193/125;
                }

                .cz2__ai-modal__disclaimer {
                    width: 100%;
                }

                @include respond-above(md) {
                    .cz2__ai-modal__selfie-example {
                        margin-bottom: 16px;
                        width: 386px;
                        height: 250px;
                    }

                    .cz2__ai-modal__disclaimer {
                        max-width: 730px;
                    }
                }
            }

            .cz2__modal-popup__copy {
                max-width: 610px;
                line-height: normal;
            }
        }
    }
</style>

<script>
    import Btn from '../ui/Btn.vue';
    import BaseDisclaimer from './BaseDisclaimer.vue';

    export default {
        components: {
            Btn,
            BaseDisclaimer,
        },

        computed: {
            aiSelfieStates() {
                return this.$store.state.aiSelfieStates;
            },
        },

        methods: {
            openSayCheeseState() {
                this.$store.dispatch('setAiSelfieActiveState', this.aiSelfieStates.sayCheese);
            },
        },
    };
</script>
